import { flow, pipe, spy } from "@morphism/fp";
import React from "react";
import ReactDOM from "react-dom";

import { AppAuthenticationWrapper } from "~/Auth";

// eslint-disable-next-line functional/no-expression-statement,functional/immutable-data
window.hole = () => {
  // eslint-disable-next-line functional/no-throw-statement
  throw Error("Unfilled hole!");
};

// eslint-disable-next-line functional/no-expression-statement,functional/immutable-data
window.flow = flow;

// eslint-disable-next-line functional/no-expression-statement,functional/immutable-data
window.pipe = pipe;

// eslint-disable-next-line functional/no-expression-statement,functional/immutable-data
window.spy = spy;

const main = () => {
  return ReactDOM.render(
    <AppAuthenticationWrapper />,
    document.getElementById("app")
  );
};

import "../../node_modules/antd/dist/antd.less";
import "../../node_modules/mapbox-gl/dist/mapbox-gl.css";

main();
